import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'
import InputGroup from '../ui-components/InputGroup'
import DatePicker from '../date-picker'
import Timepicker from '../timepicker/Timepicker'
import DateFormatter from './DateFormatter'

interface Props {
  enableModal: boolean,
  onSchedulePublish: () => void,
  onClose: () => void,
  scheduledDateInputValue: {
    date: Date[] | null,
    hours: string | null,
    minutes: string | null,
    period: string | null,
    error: string
  },
  setDate: (field: string, value: Date[] | string | null) => void
}

const SchedulePublishModal = (props: Props) => {
  const {
    enableModal,
    onSchedulePublish,
    onClose,
    scheduledDateInputValue: scheduledDate,
    setDate
  } = props

  const timezoneLong = DateFormatter.timezone('long')
  const timezoneShort = DateFormatter.timezone('short')

  return (
    <Modal isOpen={enableModal} size='medium'>
      <ModalHeader title='Schedule publishing' onClose={onClose} />
      <ModalBody>
        <span class='control-bold'>Timezone:</span> {timezoneLong} ({timezoneShort})
        <div className='article-creator__schedule-publish-modal-date'>
          <InputGroup
            title='Date'
            customInput={
              <DatePicker
                onChange={(d: Date[]) => setDate('date', d)}
                value={scheduledDate.date ? scheduledDate.date[0] : undefined}
                error={Boolean(scheduledDate.error)} />
            }
          />
          <InputGroup
            title='Time'
            customInput={
              <Timepicker
                hours={scheduledDate.hours || undefined}
                minutes={scheduledDate.minutes || undefined}
                period={scheduledDate.period || undefined}
                onHoursChange={(h: string | null) => setDate('hours', h)}
                onMinutesChange={(m: string | null) => setDate('minutes', m)}
                onPeriodChange={(p: string | null) => setDate('period', p)}
                error={Boolean(scheduledDate.error)} />}
          />
        </div>
        {scheduledDate.error && <div class='article-creator__schedule-publish-validation-error'>{scheduledDate.error}</div>}
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Schedule' variant='primary' onClick={onSchedulePublish} class='qa-schedule' />
        <ButtonControl title='Cancel' onClick={onClose} />
      </ModalFooter>
    </Modal>
  )
}

export default SchedulePublishModal
